import script from "./OrdemCompraItensSmartMode.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdemCompraItensSmartMode.vue?vue&type=script&setup=true&lang=js"

import "./OrdemCompraItensSmartMode.vue?vue&type=style&index=0&id=2a75bf0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a75bf0c"]])

export default __exports__